import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ENABLE_NOTIFICATIONS } from '../../processENV';
import { blockOfflineAction, getLocalWebsettings, setLocalWebsettings } from '../../../Helpers/Utility';
import { getFromLocalStorageAndDecrypt, encryptAndStoreInLocalStorage } from '../WebChatEncryptDecrypt';
import SDK from '../../SDK';
import { ArrowBackSettings, IconPrivacy } from '../../../assets/images';
import CommonSwitch from '../Common/CommonSwitch';
import {
    BlockedIcon,
    chat as ChatIcon,
    InfoIcon,
    InformationIcon,
    LogoutIcon,
    NextArrow,
    NotificationIcon,
    StarredMessage,
    Archived,
    IconcontactUs,
    IconDelete,
} from './images';

const imageComponent = {
    chat: ChatIcon,
    Archived: Archived,
    notification: NotificationIcon,
    blocked: BlockedIcon,
    about: InfoIcon,
    policy: InformationIcon,
    logout: LogoutIcon,
    star: StarredMessage,
    delete: IconDelete,
    contactUs: IconcontactUs,
    Privacy: IconPrivacy,
};

export const SettingCheckBox = (props = {}) => {
    const { id, label, getaAtion, chat = false, children, dafaultSetting } = props;
    const settingsData = useSelector(state => state.settingsData.data[id]);
    const [activeSettings, setActiveSettings] = useState(dafaultSetting || false);

    const chatSetting = () => {
        if (blockOfflineAction()) return;
        setActiveSettings(!activeSettings);
        getaAtion(!activeSettings);
    };

    const settingListener = () => {
        if (blockOfflineAction()) return;
        const newCheckedState = !activeSettings;
        if (Notification.permission === 'denied' || Notification.permission === 'default') {
            setActiveSettings(false);
            toast.error(ENABLE_NOTIFICATIONS, {
                toastId: 'Notification',
            });
        } else {
            const muteEnabled = !newCheckedState;
            setActiveSettings(newCheckedState);
            SDK.updateMuteNotificationSettings(muteEnabled);
            const webSettings = getFromLocalStorageAndDecrypt('websettings');
            let parserLocalStorage = webSettings ? JSON.parse(webSettings) : {};
            const constructObject = {
                ...parserLocalStorage,
                [id]: muteEnabled,
            };
            encryptAndStoreInLocalStorage('websettings', JSON.stringify(constructObject));
        }
    };

    useEffect(() => {
        if (!chat) {
            if (Notification.permission === 'denied' || Notification.permission === 'default') {
                setActiveSettings(false);
            } else {
                const webSettings = getFromLocalStorageAndDecrypt('websettings');
                const settings = getLocalWebsettings();
                if (settings.Notifications === undefined) {
                    setLocalWebsettings('Notifications', true);
                    setActiveSettings(true);
                } else {
                    let parserLocalStorage = JSON.parse(webSettings);
                    const { [id]: status = false } = parserLocalStorage;
                    setActiveSettings(status);
                }
            }
        }
    }, [settingsData]);

    return (
        <li className="setting-list">
            <div className="setting-list-option">
                <div>
                    <div className="setting_label-text">{label}</div>
                    {children}
                </div>
                <CommonSwitch
                    id={id}
                    checked={chat ? dafaultSetting : activeSettings}
                    handleClick={chat ? chatSetting : settingListener}
                />
            </div>
        </li>
    );
};

export const SettingOptions = (props = {}) => {
    const { handleOptions, label, image, enableRightArrow = true, children } = props;
    const { [image]: Icon } = imageComponent;
    return (
        <li
            className="setting-list"
            onClick={() => handleOptions(image)}
            onKeyDown={e => e.key === 'Enter' && handleOptions(image)}
            tabIndex="0"
            role="button"
        >
            <div className="setting-option">
                {Icon && (
                    <i className="iconLeft">
                        <Icon />
                    </i>
                )}
                <span className="Option-text">{label}</span>
                {enableRightArrow && (
                    <i className="iconNext">
                        <NextArrow />
                    </i>
                )}
            </div>
            {children}
        </li>
    );
};

export const SettingsHeader = props => {
    const { handleBackFromSetting, label, parrentView = false } = props;
    return (
        <div className="recent-chatlist-header">
            <div className={`setting-header-text ${parrentView ? 'hideback' : ''}`}>
                {!parrentView ? (
                    <button onClick={handleBackFromSetting} className="sub-heading-container">
                        <div
                            className={`newchat-icon`}
                            style={{
                                height: '1.5rem',
                                padding: '0',
                                marginLeft: '-0.5rem',
                            }}
                            title="Back"
                        >
                            <ArrowBackSettings />
                        </div>
                        <p className="sub-heading">{label}</p>
                    </button>
                ) : (
                    <h3 className="ting_tittle">{label}</h3>
                )}
            </div>
        </div>
    );
};

SettingCheckBox.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    getaAtion: PropTypes.func,
    chat: PropTypes.bool,
    children: PropTypes.node,
    dafaultSetting: PropTypes.bool,
};

SettingOptions.propTypes = {
    handleOptions: PropTypes.func,
    label: PropTypes.string,
    image: PropTypes.string,
    enableRightArrow: PropTypes.bool,
    children: PropTypes.node,
};

SettingsHeader.propTypes = {
    handleBackFromSetting: PropTypes.func,
    label: PropTypes.string,
};
